// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__7CHBL","tab":"Tabs_tab__ZxoB3","tabActive":"Tabs_tabActive__31f5n"};